import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import { Box, Button, Stack } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { FaMapMarkerAlt } from "react-icons/fa";
import StarIcon from '@mui/icons-material/Star';
import CustomDivider from '../utils/CustomDivider';
import { ImagePath, ImageRelativePath } from '../constants';


const CompetetionCourseCard = ({ item }) => {
    const navigate = useNavigate()
    const { title, location_name, is_featured, id, cover_image, slug, type } = item

    const getPathByType = (id) => {
        switch (id) {
            case "35":
                return "/PollingOfCompetition";
            case "26":
                return "/FinalPriceDestribution";
            default:
                return "/";
        }
    };
    return (
        <Card
            sx={{
                position: "relative",
                height: "450px",
                backgroundImage: `
                         linear-gradient(180deg, rgba(0, 0, 0, 0) 60.62%, #000000 85.92%),
                           url(${`${ImagePath}${ImageRelativePath}${cover_image}`})`,
                // backgroundImage: `url(${`${ImagePath}be_collab/assets/images/event/cover/${cover_image}`})`,
                backgroundSize: "cover",
                backgroundPosition: "center",
                borderRadius: "2rem",
                overflow: "hidden",
                boxShadow: "none",
            }}
        >
            <CardContent
                sx={{
                    position: "absolute",
                    px: 3,
                    pb: 2,
                    bottom: "1.5rem",
                    left: 0,
                    right: 0
                }}
            >
                <Stack alignItems={"center"} direction={"row"} justifyContent={"space-between"}>
                    <Box>
                        <Typography variant="body1" color='primary.main'>{title}</Typography>
                        <Typography variant="body2" color='primary.main' mt={0.5} sx={{ display: "flex", alignItems: "center" }}>
                            <FaMapMarkerAlt style={{ color: "#DC143C", fontSize: "16px", margin: "0 5px 0 0" }} />
                            {location_name}
                        </Typography>
                    </Box>

                    <Box
                        sx={{
                            backgroundColor: "primary.main",
                            display: "flex",
                            justifyContent: "center",
                            borderRadius: "12px",
                            px: 1,
                            py: 0.2,
                            gap: 0.5,
                            alignItems: 'center',
                            width: "13%",


                        }}
                    >
                        <Typography variant='body2' color='red.main'>4</Typography>
                        <StarIcon sx={{ color: "red.main", fontSize: "0.9rem" }} />
                    </Box>

                </Stack>
                <CustomDivider size={"1rem"} />
                <Button
                    variant='contained'
                    fullWidth
                    onClick={() => navigate(getPathByType(String(item.id)))}
                    style={{ boxShadow: "0px 4px 4px 0px #00000040 inset" }}
                >Learn More</Button>

            </CardContent>
        </Card>
    )
}

export default CompetetionCourseCard
